<script setup>

</script>

<template>
    <div id="wrapper">
        <!-- content -->
        <div class="d-flex flex-column mainContent loginPage" id="content-wrapper">
            <div id="content">
                <!-- Main Content -->
                <router-view></router-view>
                <!-- Main Content  End-->
            </div>
        </div>
        <!-- content end -->
    </div>
</template>
